import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`bg-${_ctx.color} w-${_ctx.width} h-${_ctx.height} my-${_ctx.marginY} mx-${_ctx.marginX}`)
  }, null, 2))
}